module.exports = __webpack_public_path__ + "img/connect.a6201a8a.jpeg";